import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxColor } from '@onyx/angular';
import { OnyxInformationHeadingComponent } from '@onyx/angular';

@Component({
  selector: 'app-swap-modal-note-item',
  imports: [OnyxInformationHeadingComponent, TranslatePipe],
  templateUrl: './swap-modal-note-item.component.html',
  styleUrl: './swap-modal-note-item.component.scss',
})
export class SwapModalNoteItemComponent {
  public readonly note = input.required<string | null>();
  public readonly identifierColor = input.required<OnyxColor | null>();
}
